import { render, staticRenderFns } from "./StudentProfileOverview.vue?vue&type=template&id=c9cbad74&scoped=true"
import script from "./StudentProfileOverview.vue?vue&type=script&lang=js"
export * from "./StudentProfileOverview.vue?vue&type=script&lang=js"
import style0 from "./StudentProfileOverview.vue?vue&type=style&index=0&id=c9cbad74&prod&lang=css"
import style1 from "./StudentProfileOverview.vue?vue&type=style&index=1&id=c9cbad74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9cbad74",
  null
  
)

export default component.exports